import { MenuItem, TextField } from "@mui/material";
import type { FC } from "react";
import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";
import type { Permissions } from "../../server/supabase-person-service";
import type { PermissionsFormType } from "../../types";

export const PermissionTypeSelect: FC<{
  control: Control<PermissionsFormType>;
  existing?: Permissions;
  showReviewerOption: boolean;
}> = ({ control, showReviewerOption }) => {
  return (
    <Controller
      name="type"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          label="Permission Type"
          select
          fullWidth
          sx={{ mt: 2 }}
          helperText={error?.message}
          error={!!error}
          {...field}
        >
          <MenuItem value="super_admin">Super Admin</MenuItem>
          <MenuItem value="contributor">Contributor</MenuItem>
          {showReviewerOption && <MenuItem value="reviewer">Reviewer</MenuItem>}
        </TextField>
      )}
    />
  );
};
